

export const BlueArrowDown = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
            <path id="Polygon_14" data-name="Polygon 14" d="M5.5,0,11,11H0Z" transform="translate(11 11) rotate(180)" fill="#0a8ce0" />
        </svg>

    )
}

export const DoubbleBlueArrowDown = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15">
        <g id="Group_49" data-name="Group 49" transform="translate(-495 -600)">
          <path id="Polygon_14" data-name="Polygon 14" d="M3.5,0,7,7H0Z" transform="translate(502 615) rotate(180)" fill="#0a8ce0"/>
          <path id="Polygon_17" data-name="Polygon 17" d="M3.5,0,7,7H0Z" transform="translate(495 600)" fill="#0a8ce0"/>
        </g>
      </svg>
      

    )
}


export const RightBlueArrow=()=>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 18 18">
  <path id="Polygon_18" data-name="Polygon 18" d="M9,0l9,18H0Z" transform="translate(18) rotate(90)" fill="#0a8ce0"/>
</svg>

    )
}

